module.exports = __webpack_public_path__ + "img/mercado-icon.7598c2b2.png";